(()=>{
  'use strict';
  // Reuse the current Porada data and prices, scoped to the Joint preview.
  const id=new URL(location.href).searchParams.get('draft_product')||String(window.FultonsPriceTrial?.productId||'');
  if(id!=='15888216293759')return;
  const make=(tag,cls,text)=>{const node=document.createElement(tag);if(cls)node.className=cls;if(text)node.textContent=text;return node;};
  const normal=value=>value.normalize('NFKD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/\b(marble|glass|top)\b/g,'').replace(/\s+/g,' ').trim();
  const apply=()=>{
    const section=document.getElementById('PoradaOptions');
    if(!section||section.dataset.jointComparison)return false;
    const cards=[...section.querySelectorAll('.porada-options__model')];
    const samples=[...section.querySelectorAll(':scope > .porada-options__swatches')];
    if(cards.length!==4||samples.length!==3)return false;
    const groups=samples.map(node=>({node,label:node.querySelector('summary').textContent.split('·')[0].trim(),options:[...node.querySelectorAll('li')].map(li=>({label:li.textContent.trim(),image:li.querySelector('img')}))}));
    if(!groups.some(group=>group.label==='Frame'&&group.options.length===3))return false;
    section.dataset.jointComparison='true';
    section.classList.add('fultons-joint-comparison');
    cards.forEach(card=>{
      const allowed=[...card.querySelectorAll('.porada-options__finish-list li')].map(li=>normal(li.textContent));
      const visual=make('div','fultons-joint-comparison__visual');
      const information=make('div','fultons-joint-comparison__information');
      const finishes=make('div','fultons-joint-comparison__finishes');
      const photograph=card.querySelector('.porada-options__photo');
      const caption=card.querySelector('.porada-options__caption');
      if(photograph)visual.append(photograph);
      if(caption){caption.textContent='One table shown · illustrative finish';visual.append(caption);}
      for(const child of [...card.children]){
        if(child.matches('.porada-options__finish-list')){child.remove();continue;}
        if(child.matches('.porada-options__pricing')){
          [...child.querySelectorAll('.porada-options__table-wrap')].forEach(table=>information.append(table));child.remove();
        }else information.append(child);
      }
      groups.filter(group=>group.label!=='Top').sort((a,b)=>a.label==='Frame'?-1:b.label==='Frame'?1:0).forEach(group=>{
        const options=group.options.filter(option=>allowed.includes(normal(option.label)));
        if(!options.length)return;
        const block=make('div','fultons-joint-comparison__finish-group');
        block.append(make('h4',null,group.label==='Frame'?'Wood finishes':'Metal finishes'));
        const list=make('ul','fultons-joint-comparison__samples');
        options.forEach(option=>{
          const item=make('li');
          if(option.image){const image=option.image.cloneNode(true);image.width=64;image.height=64;item.append(image);}
          item.append(make('span',null,option.label));list.append(item);
        });
        block.append(list);finishes.append(block);
      });
      const top=groups.find(group=>group.label==='Top');
      information.querySelectorAll('tr').forEach(row=>{
        const cell=row.querySelector('td');if(!cell||!top)return;
        const option=top.options.find(option=>normal(option.label)===normal(cell.textContent));
        if(!option?.image)return;
        const label=make('span',null,cell.textContent);
        const image=option.image.cloneNode(true);image.width=40;image.height=40;
        const sample=make('span','fultons-joint-comparison__top');sample.append(image,label);cell.replaceChildren(sample);
      });
      const priceCaption=information.querySelector('caption');if(priceCaption)priceCaption.textContent='Top finish · price for one table';
      card.replaceChildren(visual,information,finishes);
    });
    samples.forEach(node=>node.remove());
    [...section.children].filter(node=>node.tagName==='H2'&&node.textContent==='Finish samples').forEach(node=>node.remove());
    const note=section.querySelector(':scope > .porada-options__note');
    if(note)note.textContent='Finish samples are a guide. Natural wood grain and marble markings vary; the photograph shows an illustrative finish.';
    if(location.hash==='#PoradaOptions')section.scrollIntoView({block:'start'});
    return true;
  };
  const start=()=>{
    if(apply())return;
    const root=document.getElementById('MainContent');if(!root)return;
    const observer=new MutationObserver(()=>{if(apply())observer.disconnect();});
    observer.observe(root,{childList:true,subtree:true});
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
